import { Box, IconButton } from "@mui/material"
import { MoreVertOutlined } from "@mui-symbols-material/w300"
import type { Row } from "@tanstack/react-table"
import { type ReactElement, useRef, useState } from "react"
import type { UseQueryExecute } from "urql"

import type { Instruction } from "@/graphql/codegen/graphql"
import ProductDropdownMenu from "@/screens/Products/components/Product/Instructions/components/rowActions/ProductDropdownMenu"
import useRemoveInstructionsFromProduct from "@/screens/Products/components/Product/Instructions/hooks/useRemoveInstructionsFromProduct"

interface ProductActionsProps {
  row: Row<Instruction>
  refetchInstructionList: UseQueryExecute
  productId: number
}

export const ProductActions = ({ row, refetchInstructionList, productId }: ProductActionsProps): ReactElement => {
  const instruction = row.original
  const instructionId = instruction.instructionId
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const { removeInstructionsFromProduct } = useRemoveInstructionsFromProduct()

  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const removeProductsAssociation = async (): Promise<void> => {
    const success = await removeInstructionsFromProduct({
      instructionIds: [instructionId],
      productId,
    })
    if (success) {
      refetchInstructionList()
    }
  }

  return (
    <Box className='flex items-center justify-end space-x-4'>
      <Box className='flex items-center justify-end' ref={anchorElRef}>
        <IconButton onClick={handleOpen}>
          <MoreVertOutlined />
        </IconButton>
        <ProductDropdownMenu
          onRemoveInstruction={removeProductsAssociation}
          open={open}
          anchorEl={anchorElRef.current}
          onClose={handleClose}
        />
      </Box>
    </Box>
  )
}
